<template>
	<router-view/>
</template>

<script>
export default {
	name: 'Accountant.vue'
}
</script>

<style scoped>

</style>
